import React from "react";
import FlightInfoLine from './components/FlightInfoSquareLine/FlightInfoLine';
import {If, Then} from "react-if";
import {IProduct} from 'data/interfaces/products';
import styles from "./FlightInfoSquare.module.scss";
import {SizeMe} from 'react-sizeme';

export interface IFlightInfoSquare {
  product: IProduct;
  style: any;
  showIcon: boolean;
}

const FlightInfoSquare = (props: IFlightInfoSquare) =>
  (<SizeMe>{({size: {width}}) => {
    return (<span className={`${styles.flightInfoSquare} ${width <= 627 ? 'mobile' : ''}`.trim()}>
    <FlightInfoLine className={styles.firstLine} ticketDetails={props.product.ticketDetails}/>
    <If
      condition={!!(props.product.ticketDetails.destinationTimeOfTakeOff && props.product.ticketDetails.destinationTimeOfLanding)}>
      <Then>
        {() => (
          <FlightInfoLine className={'secondLine'} ticketDetails={props.product.ticketDetails} flip/>
        )}
      </Then>
    </If>
  </span>);
  }
  }</SizeMe>);

FlightInfoSquare.defaultProps = {
  showIcon: true,
  style: {},
};

export default FlightInfoSquare;
